import React, { useEffect } from 'react';
import './contextMenu.css';
import { useDispatch } from "react-redux";
import { contextAction } from "../../redux/rootReducer";

const ContextMenu = ({ data }) => {
    const dispatch = useDispatch();

    const clickHandler = event => {
        if (!data.open) return false;

        // Если клик произошёл вне контекстного окна, закрываем его
        if (!event.target.closest('.context')) {
            dispatch(contextAction(null));
        }
    };

    useEffect(() => {
        document.querySelector('.layout').addEventListener('click', clickHandler);

        return () => {
            document.querySelector('.layout').removeEventListener('click', clickHandler);
        };
    }, [data.open]);

    if (!data?.open) return false;

    return (
        <div className="context" style={ data.style }>
            {
                data.menu.filter(el => el.caption).map(elem => {
                    return (
                        <div
                            className="context__item"
                            key={ elem.id }
                            onClick={ elem.handler }
                        >{ elem.caption }</div>
                    );
                })
            }
        </div>
    );
};

export default ContextMenu;